/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binary (base 2), octal (base 8), decimal (base 10), and hexadecimal (base 16). Hexadecimal output uses uppercase A–F.`)
};

const es_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario (base 2), octal (base 8), decimal (base 10) y hexadecimal (base 16). La salida hexadecimal usa mayúsculas A–F.`)
};

const de_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binär (Basis 2), Oktal (Basis 8), Dezimal (Basis 10) und Hexadezimal (Basis 16). Die Hexadezimal-Ausgabe verwendet Großbuchstaben A–F.`)
};

const nl_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binair (basis 2), octaal (basis 8), decimaal (basis 10) en hexadecimaal (basis 16). Hexadecimale uitvoer gebruikt hoofdletters A–F.`)
};

const fr_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaire (base 2), octal (base 8), décimal (base 10) et hexadécimal (base 16). La sortie hexadécimale utilise des majuscules A–F.`)
};

const it_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binario (base 2), ottale (base 8), decimale (base 10) ed esadecimale (base 16). L'output esadecimale utilizza maiuscole A–F.`)
};

const pt_br2_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário (base 2), octal (base 8), decimal (base 10) e hexadecimal (base 16). A saída em hexadecimal usa maiúsculas A–F.`)
};

const pt_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binário (base 2), octal (base 8), decimal (base 10) e hexadecimal (base 16). A saída de hexadecimal utiliza maiúsculas A–F.`)
};

const ja_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二進法（基数 2）、八進法（基数 8）、十進法（基数 10）、十六進法（基数 16）。十六進法の出力は大文字の A～F を使用します。`)
};

const zh_nb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二进制（2 进制）、八进制（8 进制）、十进制（10 进制）和十六进制（16 进制）。十六进制输出使用大写字母 A-F。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq1_a", locale)
	if (locale === "en") return en_nb_faq1_a(inputs)
	if (locale === "es") return es_nb_faq1_a(inputs)
	if (locale === "de") return de_nb_faq1_a(inputs)
	if (locale === "nl") return nl_nb_faq1_a(inputs)
	if (locale === "fr") return fr_nb_faq1_a(inputs)
	if (locale === "it") return it_nb_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq1_a(inputs)
	if (locale === "pt") return pt_nb_faq1_a(inputs)
	if (locale === "ja") return ja_nb_faq1_a(inputs)
	return zh_nb_faq1_a(inputs)
};